<div class="textpages__content textpages__promos">
    <div class="textpages__promos-item" v-if="promos.length === 0">
        <div class="textpages__content-col0">
            <span v-html="pageData"></span>
            <span v-if="!isLoggedIn()">
                <a class="btn btn-orange btn-small mr" @click="toggleModal('login')">{{ $t('header.user.login') }}</a>
                <a class="btn btn-green btn-small" @click="toggleModal('register')">{{ $t('header.user.register') }}</a>
            </span>
            <span v-if="isLoggedIn()">
                <router-link class="btn btn-orange btn-small mr" :to="{name:'payment'}">{{ $t('header.user.credits') }}</router-link>
            </span>
        </div>
    </div>
    <div class="textpages__promos-item" v-for="promo in promos" v-if="promos.length > 0">
        <div class="textpages__content-col2">
            <span v-html="pageData"></span>
            <span v-if="!isLoggedIn()">
                <a class="btn btn-orange btn-small mr" @click="toggleModal('login')">{{ $t('header.user.login') }}</a>
                <a class="btn btn-green btn-small" @click="toggleModal('register')">{{ $t('header.user.register') }}</a>
            </span>
            <span v-if="isLoggedIn()">
                <router-link class="btn btn-orange btn-small mr" :to="{name:'payment'}">{{ $t('header.user.credits') }}</router-link>
            </span>
            <span v-html="promo.text2"></span>
        </div>
        <div class="textpages__content-col2">
            <img :src="getStaticImages('happyhour', 'png')" />
            <span v-html="promo.text1"></span>
        </div>
    </div>
</div>
